import React from 'react'
import { Paper, Stack, Text } from '@mantine/core'
import ErrorLoading from '../../../react/core/ErrorLoading'
import Loading from '../../../react/core/Loading'
import JobPostingRow from '../../components/JobPostingRow'
import { useGetJobBoardJobsQuery } from '../redux/query/jobBoardApi.slice'

function JobList ({ filters }) {
  const { data: jobs, isError, isFetching } = useGetJobBoardJobsQuery({ limit: 0, ...filters })

  if (isError) {
    return <ErrorLoading />
  }

  if (isFetching) {
    return <Loading />
  }

  return (
    <Paper pl='40px' pr='40px'>
      <Stack>
        {
          jobs.items.length !== 0
            ? jobs.items.map(job => (
                <JobPostingRow
                  key={job.identifier}
                  job={job}
                  color='blue'
                  to={job.identifier}
                  openInNewTab={false}
                />
            )
            )
            : <Text size='lg'>Currently there are no job openings for the selected filters. Please check back again.</Text>
        }
      </Stack>
    </Paper>
  )
}

export default React.memo(JobList)
